<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$t('jianyanbaobiaomingxi')" ref="yt" getUrl="/web/quality/inspection/record/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jianyandanhao')">
            <el-input v-model="yt.conditions.inspectionNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" rexiauired>
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('jianyanzhuangtai')">
            <yi_dictionary_select type="QUALITY_INSPECTION_STATUS" :max="4" :multiple="true" :ids.sync="yt.conditions.statusList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shenhezhuangtai')">
            <yi_dictionary_select type="QUALITY_INSPECTION_CHECK_STATUS" :ids.sync="yt.conditions.checkStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')">
            <yi_dictionary_select type="QUALITY_INSPECTION_TYPE" :ids.sync="yt.conditions.inspectionType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jihuawanchengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planTimeStart" :end.sync="yt.conditions.planTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shijijianyanshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.actualTimeStart" :end.sync="yt.conditions.actualTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
export default {
  props: {
    formData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'jianyandanhao',
          prop: 'inspectionNo',
          width: 150
        },
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no',
          width: 130
        },
        {
          label: 'gongxumiaoshu',
          prop: 'woProcedure.procedureDesc',
          width: 130
        },
        {
          label: 'jianyanleixing',
          prop: 'inspectionType',
          type: 'dictionary',
          key: 'QUALITY_INSPECTION_TYPE',
          width: 130
        },
        {
          label: 'jianyanfangshi',
          prop: 'inspectionMethod.name',
          width: 130
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'sehao',
          prop: 'plan.colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 130,
          show: false
        },
        {
          label: 'shijimaozhongke',
          prop: 'actualGrossWeight',
          width: 130
        },
        {
          label: 'shijijingzhongke',
          prop: 'actualNetWeight',
          width: 130
        },
        {
          label: 'jianyanbiaozhunmingcheng',
          prop: 'inspectionStandardName',
          width: 130
        },
        {
          label: 'jianyanbiaozhunbanben',
          prop: 'version',
          width: 130
        },
        {
          label: 'songjianshuliang',
          prop: 'submitInspectionNum',
          width: 130
        },
        {
          label: 'jihuajianyanshuliang',
          prop: 'planNum',
          width: 130
        },
        {
          label: 'jihuajianyanshijian',
          prop: 'planTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm',
          width: 130
        },
        {
          label: 'shijijianyanshijian',
          prop: 'actualTime',
          type: 'time',
          width: 130
        },
        {
          label: 'jianyanyuan',
          prop: 'inspector.nickname',
          width: 130
        },
        {
          label: 'jianyanzhuangtai',
          prop: 'status',
          type: 'tag',
          width: 130,
          tags: {
            '1': {
              color: '#E6A23C',
              text: this.$t('weijianyan')
            },
            '2': {
              color: '#67C23A',
              text: this.$t('jianyanhege')
            },
            '3': {
              color: '#F56C6C',
              text: this.$t('jianyanbuhege')
            },
            '4': {
              color: '#909399',
              text: this.$t('zuofei')
            }
          }
        },
        {
          label: 'shenhezhuangtai',
          prop: 'checkStatus',
          type: 'tag',
          width: 130,
          tags: {
            '0': {
              color: '#ff8959',
              text: this.$t('daishenhe')
            },
            '1': {
              color: '#9254de',
              text: this.$t('yishenhe')
            }
          }
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 130
        },
      ],
    }
  },
  created() {
    setTimeout(() => {
      if(this.formData.createTimeStart && this.formData.createTimeEnd){
        this.$set(this.yt.conditions,'createTimeStart', this.formData.createTimeStart);
        this.$set(this.yt.conditions,'createTimeEnd', this.formData.createTimeEnd);
      }
      if(this.formData.planTimeStart && this.formData.planTimeEnd){
        this.yt.conditions.planTimeStart = this.formData.planTimeStart;
        this.yt.conditions.planTimeEnd = this.formData.planTimeEnd;
      }
      if(this.formData.actualTimeStart && this.formData.actualTimeEnd){
        this.yt.conditions.actualTimeStart = this.formData.actualTimeStart;
        this.yt.conditions.actualTimeEnd = this.formData.actualTimeEnd;
      }
      if(this.formData.statusList){
        this.yt.conditions.statusList = this.formData.statusList;
      }
      if (this.formData.inspectionType){
        this.$set(this.yt.conditions,'inspectionType', this.formData.inspectionType);
      }
      this.yt.get(1);
    }, 300);
  }
}
</script>

<style scoped lang="scss">

</style>